var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isConfigLoaded)?_c('Loader'):_c('keep-alive',{attrs:{"include":!_vm.homeMode.startsWith('flow') ? 'Home': '-'}},[_c('router-view',{staticClass:"view-home",attrs:{"id":"view-home"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }